import {createSelector} from 'reselect'
import {generatePath} from '@modifi/router'
import {FeInputFieldStatus} from '@modifi/enums'

import {selectCompanyIsLocked} from '../../../../data/company'
import {selectCombinedInputFieldStatusBySectionName} from '../../../../modules/input-fields'
import {ROUTE_COMPANY_PROFILE_BENEFICIAL_OWNERS_BY_ID} from '../../../../routes/constants'
import {selectBeneficialOwners} from '../../../../data/beneficial-owners'
import DeleteBeneficialOwnerButton from '../../../../features/delete-beneficial-owner'
import {SECTION_ULTIMATE_BENEFICIAL_OWNERS} from '../../../../constants/sections'

export const selectUBOSummaryData = createSelector(
  selectBeneficialOwners,
  selectCompanyIsLocked,
  (state: Record<string, any>) => state,
  (beneficialOwners, companyIsLocked, state) => {
    const isVerified =
      selectCombinedInputFieldStatusBySectionName(state, SECTION_ULTIMATE_BENEFICIAL_OWNERS) ===
      FeInputFieldStatus.VERIFIED
    const summaryData = beneficialOwners.map(ubo => {
      const name = `${ubo?.firstName} ${ubo?.lastName} `
      return {
        route: generatePath(ROUTE_COMPANY_PROFILE_BENEFICIAL_OWNERS_BY_ID, {
          externalId: ubo?.externalId,
        }),
        name,
        votingSharePercentage: ubo?.votingShare,
        deleteButton: companyIsLocked || isVerified ? null : DeleteBeneficialOwnerButton,
        deleteProps: {target: name, externalPersonId: ubo?.externalId},
      }
    })
    return summaryData
  }
)
